var _circle, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRecurringGreen = function SvgRecurringGreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#F2FCED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 6.50033C8.68613 6.50033 5.99984 9.18662 5.99984 12.5003C5.99984 15.814 8.68613 18.5003 11.9998 18.5003C15.3135 18.5003 17.9998 15.814 17.9998 12.5003C17.9998 12.1321 18.2983 11.8337 18.6665 11.8337C19.0347 11.8337 19.3332 12.1321 19.3332 12.5003C19.3332 16.5504 16.0499 19.8337 11.9998 19.8337C7.94975 19.8337 4.6665 16.5504 4.6665 12.5003C4.6665 8.45024 7.94975 5.16699 11.9998 5.16699C14.5598 5.16699 16.8129 6.47922 18.1237 8.4646C18.3266 8.77187 18.2419 9.1854 17.9347 9.38827C17.6274 9.59113 17.2139 9.5065 17.011 9.19924C15.9365 7.57175 14.0931 6.50033 11.9998 6.50033Z",
    fill: "#347A18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.16699C18.3682 5.16699 18.6667 5.46547 18.6667 5.83366V9.16699C18.6667 9.53518 18.3682 9.83366 18 9.83366H14.6667C14.2985 9.83366 14 9.53518 14 9.16699C14 8.7988 14.2985 8.50033 14.6667 8.50033H17.3333V5.83366C17.3333 5.46547 17.6318 5.16699 18 5.16699Z",
    fill: "#347A18"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecurringGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recurring-green.f99fed50.svg";
export { ForwardRef as ReactComponent };